<p translate="error-renderer-activity-not-found-main-message"></p>

@for (error of errors | keyvalue; track error) {
  <p>
    <strong>{{error.key}}</strong>: {{error.value}}
  </p>
}

<a
  href="{{contactSupport}}"
  target="_blank"
  class="tertiary-btn stacked-item"
  translate="error-renderer-contact-support">
</a>
